import React, { useState, useEffect, useContext } from 'react';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { getGetRequestOptions } from "../components/GetToken";
import { AppContext } from '../context/AppContext';
import validationMessage from '../helpers/ValidationErrorMsg'

const customStylesSelect = {
    control: (provided) => ({
        ...provided,
        height: 'calc(1.35em + 1.1rem + 2px)',
        minHeight: '35px'
    }),
    valueContainer: (provided) => ({
        ...provided,
    })
};

const FuelLogEntry = () => {
    const { jwt } = useContext(AppContext);
    const [allBusinessUnits, setAllBusinessUnits] = useState([]);
    const [state, setState] = useState({
        logBookBusinessUnit: "",
        projectId: "",
        equipment: "",
        fuelType: "",
        tankCapacity: "",
        fuelQty: "",
        refuelingDate: "",
        previousHrsMeter: "",
        currentHrsMeter: ""
    });
    const [vehicleSearchKey, setVehicleSearchKey] = useState(0);

    useEffect(() => {
        getAllBu();
    }, []);

    const getAllBu = () => {
        fetch(process.env.REACT_APP_API_URL + "get_user_business_units",
            getGetRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                let tempResp = resp.data.map(function (element) {
                    return { ...element, label: element.projectName, value: element.projectId, isdisabled: element.projectName === 'EMD' ? false : true }
                });
                setAllBusinessUnits(tempResp);
            })
            .catch((error) => {
                console.log(error, "catch the hoop")
            });
    }

    const getEquipment = (inputValue, callback) => {
        if (!state.logBookBusinessUnit || !state.logBookBusinessUnit.projectId) {
            callback([]);
            return;
        }
        var url = "";
        if (!inputValue) {
            url = process.env.REACT_APP_API_URL + "equipment/received_equipment_search/" + state.logBookBusinessUnit.projectId;
        } else {
            url = process.env.REACT_APP_API_URL + "equipment/received_equipment_search/" + state.logBookBusinessUnit.projectId + "?q=" + inputValue;
        }
        setTimeout(() => {
            fetch(url, getGetRequestOptions())
                .then((resp) => resp.json())
                .then((resp) => {
                    const tempArray = resp.data.map(function (element) {
                        element.label = `${element.equipmentName} (${element.equipmentCode})`;
                        element.value = element.equipmentId;
                        return element;
                    });
                    callback(tempArray);
                })
                .catch((error) => {
                    console.log(error, "catch the hoop")
                });
        });
    }

    const handleEquipmentChange = equipment => {
        setState(prev => ({
            ...prev,
            equipment: equipment,
            fuelType: equipment.fuelType || "",
            tankCapacity: equipment.tankCapacity || "",
            previousHrsMeter: equipment.previousHrsMeter || ""
        }));
    }

    const handleBuChange = logBookBusinessUnit => {
        setState(prev => ({ ...prev, logBookBusinessUnit, projectId: logBookBusinessUnit.projectId, equipment: "", fuelType: "", tankCapacity: "", previousHrsMeter: "" }));
        setVehicleSearchKey(vehicleSearchKey + 1);
    }

    const handleInputOnChange = (name, value) => {
        setState(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = evt => {
        evt.preventDefault();

        const formData = {
            projectId: state.projectId,
            equipment: state.equipment.value,
            fuelType: state.fuelType,
            tankCapacity: state.tankCapacity,
            fuelQty: state.fuelQty,
            refuelingDate: state.refuelingDate,
            previousHrsMeter: state.previousHrsMeter,
            hrsMeter: state.currentHrsMeter,
            emoDetailsId: state.equipment.emoDetailsId || ""
        }

        Swal.fire({
            title: 'Are you sure?',
            text: "You want to entry this fuel log!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt.token },
                    body: JSON.stringify(formData)
                };

                fetch(process.env.REACT_APP_API_URL + "log_book/fuel_entry", requestOptions)
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success === true) {
                            let successMsg = resp.successMessage;
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: successMsg,
                            })

                            setState({
                                logBookBusinessUnit: "",
                                projectId: "",
                                equipment: "",
                                fuelType: "",
                                tankCapacity: "",
                                fuelQty: "",
                                refuelingDate: "",
                                previousHrsMeter: "",
                                currentHrsMeter: ""
                            });
                        } else {

                            const errorsMessage = validationMessage(resp.errorMessage).join("<br>");
                            Swal.fire({
                                icon: 'error',
                                title: 'Error',
                                html: errorsMessage,
                            })
                        }
                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop");
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'An error occurred while submitting the form',
                        });
                    });
            }
        });
    }

    return (
        <>
            <div className="card card-custom">
                <div className="card-header">
                    <h3 className="card-title">
                        <p className="text-primary">
                            Fuel Log Entry
                        </p>
                    </h3>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="card-body">
                        <div className="ml-12">
                            <div className='row'>
                                <div className='col-12'>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-lg-4 col-form-label text-right">Business Unit<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <Select
                                                value={state.logBookBusinessUnit}
                                                onChange={handleBuChange}
                                                options={allBusinessUnits}
                                                styles={customStylesSelect}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="example-text-input" className="col-lg-4 col-form-label text-right">Equipment<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <AsyncSelect
                                                key={vehicleSearchKey}
                                                value={state.equipment}
                                                defaultOptions
                                                loadOptions={getEquipment}
                                                placeholder="Select Equipment"
                                                onChange={handleEquipmentChange}
                                                styles={customStylesSelect}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="fuelType" className="col-lg-4 col-form-label text-right">Fuel Type<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input type="text" name="fuelType" id="fuelType" value={state.fuelType} readOnly className={`form-control form-control-md`} />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="tankCapacity" className="col-lg-4 col-form-label text-right">Tank Capacity<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">L</span>
                                                </div>
                                                <input type="text" name="tankCapacity" id="tankCapacity" value={state.tankCapacity} readOnly className={`form-control form-control-md`} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="fuelQty" className="col-lg-4 col-form-label text-right">Fuel Quantity<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">L</span>
                                                </div>
                                                <input type="number" name="fuelQty" id="fuelQty" value={state.fuelQty} onChange={(e) => handleInputOnChange('fuelQty', e.target.value)} className={`form-control form-control-md`} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label htmlFor="refuelingDate" className="col-lg-4 col-form-label text-right">Refueling Date<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input type="date" name="refuelingDate" id="refuelingDate" value={state.refuelingDate} onChange={(e) => handleInputOnChange('refuelingDate', e.target.value)} className={`form-control form-control-md`} />
                                        </div>
                                    </div>
                                    <div className='form-group row'>
                                        <label htmlFor="previousHrsMeter" className="col-lg-4 col-form-label text-right">Previous Hrs Meter<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input type="number" name="previousHrsMeter" id="previousHrsMeter" value={state.previousHrsMeter} readOnly className={`form-control form-control-md`} />
                                            <input type="hidden" name="previousHrsMeter" id="previousHrsMeter" value={state.previousHrsMeter} />

                                        </div>
                                    </div>
                                    <div className='form-group row'>
                                        <label htmlFor="currentHrsMeter" className="col-lg-4 col-form-label text-right">Current Hrs Meter<span className="required text-danger"> *</span></label>
                                        <div className="col-lg-6">
                                            <input type="number" name="currentHrsMeter" id="currentHrsMeter" value={state.currentHrsMeter} onChange={(e) => handleInputOnChange('currentHrsMeter', e.target.value)} className={`form-control form-control-md`} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="card-footer">
                        <div className="row">
                            <div className="col-6">
                            </div>
                            <div className="col-6">
                                <button type="submit" className="btn btn-success mr-2">Submit</button>
                                <button type="reset" className="btn btn-secondary">Cancel</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default FuelLogEntry;